var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.5782C14.5837 18.5782 18.3337 14.8282 18.3337 10.2448C18.3337 5.6615 14.5837 1.9115 10.0003 1.9115C5.41699 1.9115 1.66699 5.6615 1.66699 10.2448C1.66699 14.8282 5.41699 18.5782 10.0003 18.5782Z",
    stroke: "#57486D",
    strokeWidth: 1.37156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45801 10.2444L8.81634 12.6028L13.5413 7.88611",
    stroke: "#57486D",
    strokeWidth: 1.37156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.fd64167a7d3e7e3a015ba969a28d1337.svg";
export { ForwardRef as ReactComponent };